import React from 'react';
import { Button, Modal, Image, Container } from 'react-bootstrap';
import $ from 'jquery';

class ScreenshotViewer extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.getScreenshot = this.getScreenshot.bind(this);
        this.isValueSet = this.isValueSet.bind(this);
        this.clearViewer = this.clearViewer.bind(this);
        this.hideHandler = this.hideHandler.bind(this);
        this.showHandler = this.showHandler.bind(this);

        this.state = {
            screenshotOutput: null,
            logIdx: null,
            show: false
        };
    }
    clearViewer() {
        this.setState({
            screenshotOutput: null
        });
    }
    getScreenshot(logId) {
        if (logId) {
            var url = "/api/v1/extractions/" + this.props.currentExtraction?.id + "/batches/" + this.props.batchID + "/jobs/" + encodeURIComponent(logId) + "/screenshot"
            $.getBinary(url, data => {
                this.setState({
                    screenshotOutput: data,
                    logIdx: logId,
                    show: true
                });
            });
            return;
        }

        if (!this.props.isJobOutputAvailable()) {
            return;
        }
        var url = "/api/v1/extractions/" + this.props.currentExtraction.id + "/batches/" + this.props.batchID + "/jobs/" + encodeURIComponent(this.props.activeJobId) + "/screenshot"
        $.getBinary(url, data => {
            this.setState({
                screenshotOutput: data,
                show: true
            });
        });
    }
    isValueSet() {
        return this.state.screenshotOutput != null && (this.props.row_id == null || this.state.logIdx == this.props.row_id)
    }
    hideHandler() {
        this.setState({ show: false });
    }

    showHandler() {
        this.setState({ show: true });
    }
    render() {
        return (
            <div>
                <Button
                    variant="light"
                    onClick={() => this.getScreenshot(this.props.row_id)}
                >
                    Display Screenshot
                </Button>
                <div className="modal-container">
                    <Modal
                        show={this.state.show}
                        onHide={this.hideHandler}
                        centered
                        dialogClassName="asset-modal-wide"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title">
                                Screenshot
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {this.isValueSet() &&
                                <Image
                                    rounded
                                    src={'data:image/png;base64,' + this.state.screenshotOutput}
                                    alt="screenshot"
                                    width="1024"
                                />
                            }
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={this.hideHandler}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        );
    }
}

export default ScreenshotViewer;